module.exports = __webpack_public_path__ + "static/media/20150522_113352.2d72bba7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-db/20150522_113352.jpg
// module id = 443
// module chunks = 0